//@flow
import React, { Component, type Element } from 'react';
import { type Currencies } from '../../../utilities/types';
import { formatCurrency } from '../../../utilities/numberFormatting';

type Props = {
  currencies: Currencies,
  columns: Array<any>,
  data: Array<any>,
  Partial: Element<any>
};

export default class TotalCurrencyBreakdown extends Component<Props> {
  handleOptions = (rowItem: { currency: string }, i: number) => {
    const arr = [];
    this.props.columns.map(colItem => {
      if (!rowItem) return;
      const obj = {};
      obj.right = colItem.right;
      obj.customPadding = colItem.customPadding;
      if (i === 0 && colItem.showOnce) {
        if (colItem.showOnce) {
          obj.value = colItem.value;
          obj.bold = colItem.bold;
          arr.push(obj);
        }
      } else if (colItem.showOnce) {
        obj.value = '';
        arr.push(obj);
      } else {
        obj.bold = colItem.bold;
        obj.value = formatCurrency(
          rowItem[colItem.value],
          this.props.currencies[rowItem.currency]
        );
        arr.push(obj);
      }
    });
    return arr;
  };

  render() {
    const processingSumsTotal = this.props.data.length;
    const hasBorder = i => i !== processingSumsTotal - 1;
    const first = i => i === 0;

    return (
      <>
        {this.props.data.map((rowItem, i) =>
          React.cloneElement(this.props.Partial, {
            key: i,
            options: this.handleOptions(rowItem, i),
            noBorder: hasBorder(i),
            first: first(i)
          })
        )}
      </>
    );
  }
}
